<template>
  <div v-if="criteriaStore.criteria?.priceRange.min > 0" class="price-control">
    <p class="price-control__title">
      {{ _T("@Price") }}
    </p>
    <div class="price-control__container">
      <div class="price-control__counters">
        <div class="price-control__inputs">
          <label class="price-control__min-price">
            <input
              v-model="model[0]"
              type="text"
              maxlength="7"
              name="min-price"
              class="price-control__number"
            />
          </label>
          <span class="price-control__line" />
          <label class="price-control__max-price">
            <input
              v-model="model[1]"
              type="text"
              maxlength="7"
              name="max-price"
              class="price-control__number"
            />
          </label>
        </div>
        <ButtonPrimary
          class="price-control__button"
          button-width="363px"
          @click.prevent="applyModel"
        >
          OK
        </ButtonPrimary>
      </div>

      <div class="price-control__slider-wrapper">
        <Slider
          v-model="model"
          :min="criteriaStore.criteria?.priceRange.min"
          :max="criteriaStore.criteria?.priceRange.max"
          :tooltips="false"
          :classes="{
            connects: 'slider-connects range-slider__connects',
            connect: 'slider-connect range-slider__connect',
            handle: 'slider-handle range-slider__handle',
          }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ButtonPrimary from "~/modules/shared/buttons/ButtonPrimary.vue";
import { useFilterStore } from "~/store/filterStore";
import { useCriteriaStore } from "~/store/criteriaStore";
import Slider from "@vueform/slider";
import "@vueform/slider/themes/default.css";

const filterStore = useFilterStore();
const criteriaStore = useCriteriaStore();

const makeModel = () => [
  filterStore.params.minPrice ?? criteriaStore.criteria?.priceRange.min,
  filterStore.params.maxPrice ?? criteriaStore.criteria?.priceRange.max,
];

const model = ref(makeModel());

const applyModel = () => {
  filterStore.params.minPrice = Math.min(...model.value);
  filterStore.params.maxPrice = Math.max(...model.value);

  filterStore.setPage(1);
};

watch(
  [() => filterStore.params, () => criteriaStore.criteria],
  () => (model.value = makeModel()),
  { deep: true },
);
</script>

<style lang="scss">
.range-slider {
  &__connects {
    background-color: var(--color-sky-base);
  }

  &__connect {
    background-color: var(--color-primary-base);
  }

  &__handle {
    &.slider-handle {
      @include fixedHW(20px);
    }

    &:focus {
      box-shadow:
        0 0 0 3px rgba(243, 108, 33, 0.3),
        0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
    }
  }
}
</style>

<style lang="scss" scoped>
.price-control {
  @include flex-container(column, space-between);
  gap: 16px;

  border-bottom: 1px solid var(--color-sky-base);

  padding: 8px 8px 16px;

  @include bigMobile {
    background-color: var(--color-sky-lightest);
    border: none;
    border-radius: 16px;
  }

  &__title {
    @include bigMobile {
      @include font(14, 20);
    }
  }

  &__container {
    min-height: 64px;
  }

  &__counters,
  &__inputs {
    @include flex-container(row, flex-start, center);

    gap: 8px;
  }

  &__counters {
    margin-bottom: 24px;
  }

  &__min-price,
  &__max-price {
    width: 100%;

    outline: 1px solid var(--color-sky-darker);
    border-radius: 8px;

    padding: 4px 8px;
  }

  &__number {
    width: 46px;

    @include font(12, 18);
  }

  &__line {
    width: 12px;
    height: 1px;

    background-color: var(--color-grey-900);
  }

  &__button {
    @include font(12, 16);
  }

  &__slider-wrapper {
    padding-inline: 8px;
  }
}
</style>
